import { PatientGroupResponse, PatientGroupData } from './types';

/**
 * Takes the patient group data response and transforms it into
 * the form we want to use in our React state
 *
 * @param response the response returned by calling /patient/data_groups/
 */
export function createPatientGroupData(
  response: PatientGroupResponse
): PatientGroupData {
  let activeGroupId: number = null;
  if (response.groups?.length > 0) {
    // See if there is a default group
    for (const group of response.groups) {
      if (group.isDefault) {
        activeGroupId = group.id;
        break;
      }
    }
    // Otherwise, use the first group
    if (!activeGroupId) {
      activeGroupId = response.groups[0].id;
    }
  }
  return {
    activeGroupId,
    groups: response.groups
  };
}
